import React from 'react'

// كارت مجموعة حقول بعنوان صغير + شبكة (حتى 4 حقول في السطر على الشاشات الكبيرة).
// لا يستخدم position/overflow عشان قوائم الاختيار المنسدلة تقدر تطلع فوق الأقسام اللي بعده.
const MwFormSection = ({ title, subtitle, icon, children, cols = 4, className = '' }) => {
    const gridCols = {
        1: 'grid-cols-1',
        2: 'grid-cols-1 sm:grid-cols-2',
        3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
        4: 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4',
    }[cols] || 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4';

    return (
        <section className={`rounded-xl border border-slate-200 bg-white ${className}`}>
            {title && (
                <header className="flex items-center gap-2 px-4 py-2.5 border-b border-slate-100 bg-slate-50/70 rounded-t-xl">
                    {icon && <span className="w-6 h-6 rounded-md bg-indigo-50 text-indigo-600 inline-flex items-center justify-center">{icon}</span>}
                    <div className="min-w-0">
                        <h3 className="text-[13px] font-extrabold text-slate-700 leading-5">{title}</h3>
                        {subtitle && <p className="text-[11px] text-slate-400 leading-4">{subtitle}</p>}
                    </div>
                </header>
            )}
            <div className={`grid ${gridCols} gap-x-4 gap-y-3 p-4`}>
                {children}
            </div>
        </section>
    );
};

export default MwFormSection
